import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=2c93c226&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c93c226",
  null
  
)

component.options.__file = "NotFound.vue"
export default component.exports